import React from 'react';
import { ArrowDownRight, ArrowRight } from 'lucide-react';
export const Vision = () => {
  return <section id="vision" className="py-20 bg-black relative overflow-hidden" data-id="element-273">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_rgba(255,255,255,0.03)_0,_transparent_70%)]" data-id="element-274"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-275">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-276">
          <h2 className="font-['Orbitron'] text-zinc-400 mb-4 tracking-wider text-sm" data-id="element-277">
            THE FUTURE OF LEGAL ASSISTANCE
          </h2>
          <h3 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-278">
            Every Lawyer Has a <span className="text-white" data-id="element-279">"Squire"</span>
          </h3>
          <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-280">
            LexSquire's founders envision a future where every lawyer has their
            own legal squire—a dedicated AI that manages both communications and
            software, so attorneys never have to interact with clunky tools.
          </p>
        </div>
        <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 border border-white/10 rounded-sm p-8 md:p-12 backdrop-blur-sm" data-id="element-281">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-282">
            <div data-id="element-283">
              <h3 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-284">
                Like knights once relied on squires to prepare them for
                battle...
              </h3>
              <p className="font-['Space_Grotesk'] text-zinc-300 mb-6 font-light" data-id="element-285">
                Tomorrow's lawyers will rely on LexSquire to handle the
                operational burdens of intake, leaving them free to focus on the
                fight for their clients.
              </p>
              <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-286">
                By combining the best of human expertise with AI capabilities,
                LexSquire creates a seamless intake experience that converts
                more leads while reducing the administrative burden on legal
                professionals.
              </p>
            </div>
            <div className="relative" data-id="element-287">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-white/10 to-transparent rounded-sm blur-sm" data-id="element-288"></div>
              <div className="relative bg-black/80 border border-white/20 rounded-sm p-10 flex flex-col items-center justify-center text-center" data-id="element-289">
                <h4 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-290">
                  Discover Our Complete Vision
                </h4>
                <a href="/vision" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center" data-id="element-291">
                  Learn About Our Vision
                  <ArrowRight size={18} className="ml-2" data-id="element-292" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-293">
          <h3 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-294">
            Ready to transform your firm's intake process?
          </h3>
          <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-block" data-id="element-295">
            Schedule Demo
          </a>
          <p className="mt-4 text-zinc-300 font-['Space_Grotesk']" data-id="element-296">
            Or chat with our AI intake specialist to learn more{' '}
            <ArrowDownRight size={18} className="inline ml-1" data-id="element-297" />. It's a demo of
            what you can expect.
          </p>
        </div>
      </div>
    </section>;
};